import { Pipe } from '@angular/core';
import { isNumberFinite } from '../helpers/helpers';
var DegreesPipe = (function () {
    function DegreesPipe() {
    }
    DegreesPipe.prototype.transform = function (radians) {
        if (!isNumberFinite(radians)) {
            return NaN;
        }
        return radians * 180 / Math.PI;
    };
    DegreesPipe.decorators = [
        { type: Pipe, args: [{ name: 'degrees' },] },
    ];
    /** @nocollapse */
    DegreesPipe.ctorParameters = function () { return []; };
    return DegreesPipe;
}());
export { DegreesPipe };
//# sourceMappingURL=degrees.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/math/degrees.js
// module id = 258
// module chunks = 4